import React from "react";
import { Link } from "react-router-dom";

import Navbar from "../../components/navbar";
import Footer from "../../components/footer";
import ScrollToTop from "../../components/scroll-to-top";

import heroBackground from "../../assets/images/hero/pages.jpg"; // Ensure this path is correct
// import about1 from "../../assets/images/ab3.jpg";
// import about2 from "../../assets/images/ab4.jpg";
// import about3 from "../../assets/images/ab1.jpg";

import { handleGetLanguage } from "../../utils/languageStorage";
import { FaFacebookMessenger } from "react-icons/fa";

export default function Career() {
    const language = handleGetLanguage();

    return (
        <>
            <Navbar navClass="defaultscroll is-sticky" navlight={true} />

            {/* Hero Section */}
            <section
                className="relative table w-full py-24 lg:py-44 bg-cover bg-center bg-no-repeat"
                style={{ backgroundImage: `url(${heroBackground})` }}
            >
                {/* Overlay */}
                <div className="absolute inset-0 bg-black opacity-60 md:opacity-70"></div>

                {/* Content */}
                <div className="container relative z-10">
                    <div className="text-center mt-12">
                        <h3 className="text-4xl md:text-5xl lg:text-6xl font-semibold text-white tracking-wide">
                            {language === "en" ? "Rules" : "წესები"}
                        </h3>
                    </div>
                </div>

                {/* Breadcrumbs */}
                <div className="absolute bottom-5 left-0 right-0 z-10 px-3">
                    <ul className="flex justify-center items-center space-x-2 md:space-x-4">
                        <li>
                            <Link
                                to="/"
                                className="uppercase text-sm md:text-base font-bold text-white/50 hover:text-white transition duration-300"
                            >
                                ONLYBRANDS
                            </Link>
                        </li>
                        <li>
                            <i className="mdi mdi-chevron-right text-white/50"></i>
                        </li>
                        <li
                            className="uppercase text-sm md:text-base font-bold text-white"
                            aria-current="page"
                        >
                            {language === "en" ? "Rules" : "წესები"}
                        </li>
                    </ul>
                </div>
            </section>

            {/* Content Section */}
            <section className="py-16 md:py-24 px-4 bg-gray-50 dark:bg-black">
                <div className="container mx-auto">
                    <div className="prose max-w-none text-gray-800 dark:text-white">
                        {/* Intro Paragraph */}
                        <p className="text-lg md:text-xl">
                            {language === "en"
                                ? "The website ONLYBRANDS.GE is the property of GND COMPANI LLC (Registration No. 402119694) If you are able to access this website and order products, you agree to the terms of our agreement."
                                : "აღნიშნული ვებგვერდი ONLYBRANDS.GE წარმოადგენს შპს GND COMPANI (ს/კ 402119694) საკუთრებას თუ თქვენთვის ხელმისაწვდომია ამ საიტზე შესვლა და  პროდუქციის შეკვეთა  ესეიგი თქვენ ეთანხმებით ჩვენი ხელშეკრულების პირობებს.."}
                        </p>

                        {/* Section 1 */}
                        <h2 className="text-3xl md:text-4xl font-semibold text-orange-500 mt-12 mb-4 border-b-2 border-orange-300 pb-2">
                            {language === "en"
                                ? "english"
                                : "1. ზოგადი პირობები:"}
                        </h2>
                        <pre className="text-lg font md:text-xl text-wrap" style={{ fontFamily: "'FiraGO', sans-serif" }}>
                            {language === "en"
                                ? "GND COMPANI LLC (Registration No. 402119694)"
                                : `
                                    
ტერმინთა განმარტება: ჩვენ - შპს „გნდ კომპანია“  (ს/კ 402119694), შემდგომში -კომპანია; თქვენ - პირი, რომელიც შედის ვებგვერდზე; ასევე იურიდიული პირი, რომლის სახელითაც ფიზიკური პირი შედის ვებგვერდზე; ხელშეკრულება - წინამდებარე დოკუმენტი;

•	ვებგვერდით სარგებლობისას თქვენ: ადასტურებთ, რომ ხართ სრულწლოვანი 18 წელს მიღწეული ქმედუნარიანი პირი, ან 16 წელს მიღწეული პირი და გაქვთ ნებართვა შესაბამისი პირებისაგან დადოთ წინამდებარე ხელშეკრულება, მიიღოთ ვებგვერდის საშუალებით მომსახურება და განკარგოთ შესაბამისი გადახდები;
•	დაიცავთ ხელშეკრულებით გათვალისწინებულ ვებგვერდით სარგებლობის პირობებს
•	წარმოადგენთ ჩვენს მიერ მოთხოვნილ ინფორმაციას სრულად და ზუსტად, რათა ისარგებლოთ ჩვენი მომსახურებით;
•	დაიცავთ საავტორო და ინტელექტუალურ უფლებებს, არ განახორციელებთ ვებგვერდზე არსებული ინფორმაციის სრულად ან რაიმე ნაწილის კოპირებასა და გავრცელებას ნებისმიერი სახით და მიზნებისათვის;
•	არ განახორციელებთ ისეთ ქმედებებს, რომელიც მიმართულია სხვა მომხმარებლის პირადი და კონფიდენციალური ინფორმაციის, მათ შორის ანგარიშის უსაფრთხოების კოდების გაგებისაკენ და სხვა მომხმარებლის პირადი აქტივის განკარგვისაკენ;
•	არ გაასაღებთ თავს სხვა მომხმარებლად ან არ გამოიყენებთ სხვა მომხმარებლის პირად მონაცემებს და გვერდს;
•	მკაცრად დაიცავთ თქვენი პირადი ანგარიშის უსაფრთხოებას და კონფიდენციალურობას, არ გაუმჟღავნებთ ნებისმიერ მესამე პირს თქვენი გვერდის უსაფრთხოების ანგარიშებს, რათა დაცული იყოს თქვენი პირადი ანგარიშის ინფორმაცია;
•	არ განახორციელებთ ისეთი ქმედებას, რომელიც საფრთხეს უქმნის ვებგვერდის ან მომსახურების გამართულ ფუნქციონირებას;
•	არ განახორციელებთ ისეთ ქმედებას, რომელიც აკრძალულია კანონმდებლობით, ამ ხელშეკრულებითა და მსგავსი ვებგვერდების საშუალებით მომსახურების მიღებისათვის დამკვიდრებული წესებით;

                                    `}
                            <br />
                        </pre>

                                                        {/* Section 2 */}
                        <h2 className="text-3xl md:text-4xl font-semibold text-orange-500 mt-12 mb-4 border-b-2 border-orange-300 pb-2">
                            {language === "en"
                                ? "english"
                                : "2. პროდუქტის შეძენა შესაძლებელია საიტზე რეგიტრაციის შემდეგ:"}
                        </h2>
                        <pre className="text-lg font md:text-xl text-wrap" style={{ fontFamily: "'FiraGO', sans-serif" }}>
                            {language === "en"
                                ? "GND COMPANI LLC (Registration No. 402119694)"
                                : `რეგისტრაციის ან საიტზე ინფორმაციის შეყვანის შემთხვევაში თქვენ დაეთანხმებით იმას, რომ წარადგენთ მხოლოდ ზუსტ, სრულ სარეგისტრაციო ინფორმაციას, და მოახდენთ ამ ინფორმაციის განახლებას თუ ის შეიცვლება. პროდუქციის შეძენა ან კალათაში დამატება შესაძლებელია მხოლოდ საიტზე რეგისტრაციის შემდეგ. `}
                            <br />
                        </pre>
                                                        {/* Section 3 */}
                        <h2 className="text-3xl md:text-4xl font-semibold text-orange-500 mt-12 mb-4 border-b-2 border-orange-300 pb-2">
                            {language === "en"
                                ? "english"
                                : "3. ვებგვერდის გამოყენების პირობები:"}
                        </h2>
                        <pre className="text-lg font md:text-xl text-wrap" style={{ fontFamily: "'FiraGO', sans-serif" }}>
                            {language === "en"
                                ? "GND COMPANI LLC (Registration No. 402119694)"
                                : `
ჩვენგან ვერ მიიღებთ იმ მომსახურებას, რომელიც არღვევს კანონმდებლობას. ამასთანავე, თქვენ გეკრძალებათ ჩვენი სისტემების ან ამ ვებგვერდის ყოველგვარი არაუფლებამოსილი გამოყენება, რაშიც იგულისხმება ჩვენს სისტემებში არასანქცირებული შესვლა, პაროლის არასათანადო გამოყენება ან ვებსაიტზე განთავსებული ნებისმიერი ინფორმაციის არასათანადო გამოყენება. 

თქვენს მიერ ამ ვებგვერდით სარგებლობა ან მასზე ინფორმაციის მიწოდება მიიჩნევა რომ თქვენ თანახმა ხართ ჩვენ აღნიშნული ინფორმაცია გავუმჟღავნოთ და გადავცეთ: ჩვენთან აფილირებულ ნებისმიერ პირს და მის უფლებამოსილ წარმომადგენელს, ნებისმიერ სხვა პირს ან ორგანიზაციას თქვენი თანხმობით, კანონმდებლობით გათვალისწინებული ვალდებულების არსებობისას შესაბამის პირს ან ორგანოს. 

                                `}
                            <br />
                        </pre>
                                                        {/* Section 4 */}
                        <h2 className="text-3xl md:text-4xl font-semibold text-orange-500 mt-12 mb-4 border-b-2 border-orange-300 pb-2">
                            {language === "en"
                                ? "english"
                                : "4. მომხმარებლის შესახებ ინფორმაცია და მისი გამოყენების პირობები"}
                        </h2>
                        <pre className="text-lg font md:text-xl text-wrap" style={{ fontFamily: "'FiraGO', sans-serif" }}>
                            {language === "en"
                                ? "GND COMPANI LLC (Registration No. 402119694)"
                                : `
როდესაც თქვენ ჩვენი ვებგვერდის მეშვეობით ერთვებით რაიმე აქტივობაში, როგორიცაა მაგალითად ანგარიშის გახსნა და  ჩვენთან პროდუქტის შეძენა, ჩვენ შეიძლება გთხოვოთ თქვენს შესახებ გარკვეული ინფორმაციის წარმოდგენა (როგორიცაა თქვენი სახელი და გვარი, პირადი ნომერი, ელექტრონული ფოსტის მისამართი, სქესი და დაბადების თარიღი), პროდუქტის საფასურის გადახდისას ჩვენ შეიძლება ასევე გთხოვოთ წარმოადგინოთ თქვენი ბარათის ნომერი, ვადის გასვლის თარიღი, აუთენტურობის კოდი ან სხვა შესაბამისი ინფორმაცია. თქვენი ბარათის დეტალები არ ინახება ჩვენს ვებგვერდზე, რადგან გადახდა ხდება ჩვენი პარტნიორი ბანკის დაცული გვერდიდან. აქედან გამომდინარე, ჩვენ ხელი არ მიგვიწვდება თქვენი ბარათის ინფორმაციაზე. 
თქვენს მიერ მოწოდებული ინფორმაცია ჩვენს მიერ შეიძლება გამოყენებული იყოს:
•	თქვენი შეკვეთის დასამუშავებლად;
•	სტატისტიკური მონაცემების მოსაგროვებლად, მომსახურეობის გაუმჯობესების მიზნით;
•	ვებგვერდის მართვისთვის;
•	სპეციალური შემოთავაზების გასაკეთებლად, რომელმაც შეიძლება დაგაინტერესოთ და თქვენთვის ინფორმაციის მოსაწოდებლად.

ინფორმაციის უსაფრთხოება:
ჩვენ ვატარებთ მრავალ უსაფრთხოების ზომას პირადი საიდენტიფიკაციო ინფორმაციის დასაცავად. თქვენი პირადი საიდენტიფიკაციო ინფორმაცია ჩვენს ვებგვერდზე ხელმისაწვდომია მხოლოდ თქვენი მომხმარებლის სახელისა და პაროლის მითითების შემთხვევაში. ეს პაროლი დაშიფრულია. ჩვენ გირჩევთ, რომ მესამე პირებს არ გაანდოთ თქვენი პაროლი. გარდა ამისა, თქვენი პირადი საიდენტიფიკაციო ინფორმაცია ინახება დაცულ სერვერზე, რომელზეც მხოლოდ შესაბამის პერსონალსა და კონტრაქტორებს მიუწვდებათ ხელი.

ჩვენ  არ ვაგებთ პასუხს ნებისმიერი მესამე მხარის ქმედებებზე, რომელმაც შეიძლება მიიღოს ნებისმიერი მსგავსი ინფორმაცია.

                                `}
                            <br />
                        </pre>
                                                        {/* Section 4 */}
                        <h2 className="text-3xl md:text-4xl font-semibold text-orange-500 mt-12 mb-4 border-b-2 border-orange-300 pb-2">
                            {language === "en"
                                ? "english"
                                : "5. ონლაინ შესყიდვის პროცედურა"}
                        </h2>
                        <pre className="text-lg font md:text-xl text-wrap" style={{ fontFamily: "'FiraGO', sans-serif" }}>
                            {language === "en"
                                ? "GND COMPANI LLC (Registration No. 402119694)"
                                : `
შეკვეთების მიღება ხდება ყოველდღე 24 საათის განმავლობაში. ონლაინ შესყიდვისთვის უნდა აირჩიოთ სასურველი პროდუქტი, ზომა და ფერი,  რომელიც შიგიძლიათ პირდაპირ შეიძინოთ, ასვე შეგიძლიათ იგი შეძენამდე ჩააგდოთ ვირტუალურ კალათში.  ნავიგაციისთვის შეგიძლიათ გამოიყენოთ კატეგორიები და ქვე-კატეგორიები.
                                `}
                            <br />
                        </pre>
                                                        {/* Section 4 */}
                        <h2 className="text-3xl md:text-4xl font-semibold text-orange-500 mt-12 mb-4 border-b-2 border-orange-300 pb-2">
                            {language === "en"
                                ? "english"
                                : "6. შეკვეთების გასაგზავნად გამზადება განხორციელდება:"}
                        </h2>
                        <pre className="text-lg font md:text-xl text-wrap" style={{ fontFamily: "'FiraGO', sans-serif" }}>
                            {language === "en"
                                ? "GND COMPANI LLC (Registration No. 402119694)"
                                : `
•	11:00 საათამდე მიღებული შეკვეთები თბილისის ფარგლებში გაიგზავნება იმავე დღეს
•	11:00 საათის შემდეგ მიღებული შეკვეთები გაიგზავნება მომდევნო დღეს.
•	კვირას განთავსებული შეკვეთები გაიგზავნება ორშაბათს
რეგიონებისთვის მიწოდების სერვისის დრო განსაზღვრულია 2 დან 3 სამუშაო დღემდე. შეკვეთის მიწოდება ხორციელდება ორშაბათიდან შაბათის ჩათვლით. კვირა დღეს მიწოდება არ ხორციელდება.
                                `}
                            <br />
                        </pre>
                                                        {/* Section 4 */}
                        <h2 className="text-3xl md:text-4xl font-semibold text-orange-500 mt-12 mb-4 border-b-2 border-orange-300 pb-2">
                            {language === "en"
                                ? "english"
                                : "7. პროდუქციის გაცვლა და უკან დაბრუნება:"}
                        </h2>
                        <pre className="text-lg font md:text-xl text-wrap" style={{ fontFamily: "'FiraGO', sans-serif" }}>
                            {language === "en"
                                ? "GND COMPANI LLC (Registration No. 402119694)"
                                : `
ნივთის გადასაცვლელად ან დასაბრუნებლად  თქვენ შეგიძლიათ შეტყობინება   დატოვოთ მესენჯერში,    სადაც უნდა მიუთითოთ  დასაბრუნებელი ნივთის კოდი (only4000000), ასევე გადაცვლის ან დაბრუნების მიზეზი. ასევე შეგიძლიათ დაუკავშირდეთ ოპერატორს ნომერზე 593 55 99 30 და 
ჩაანიშნინოთ  ანალოგიური მონაცემები. 
კომპანია  ცვლის ან იბრუნებს გაყიდულ ნივთს იმ შემთხვევაში, თუ მას აღმოაჩნდება თავდაპირველი ნაკლი (ისეთი ნაკლი, რომელიც მას გააჩნდა შეძენამდე და არ არის წარმოშობილი  ექსპლუატაციის შედეგად).   ასევე კომპანია    ცვლის   ან  იბრუნებს გაყიდულ ნივთს იმ შემთხვევაშიც, თუ   მოხდა არასასურველი ზომის ტანსაცმლის ან ფეხსაცმლის შეძენა.    საიტზე შეძენილი პროდუქციის გაცვლა შესაძლებელია   ერთჯერადად  ნებისმიერ პროდუქტში რაც იმ მომენტისთვის განთავსებული იქნება საიტზე  onlybrands.ge.  დაბალფასიან ნივთზე გადაცვლის შემთხვევაში თქვენ უკან დაგიბრუნდებათ გადახდილი თანხის სხვაობა, ხოლო ძვრიანი ნივთის შემთხვევაში თქვენი მხრიდან მოხდება შესაბამისი თანხის დამატება.  განვადებით  შეძენილი ნივთის  შემთხვევაში თანხა  უკან არ ბრუნდება და ხდება მხოლოდ მისი ანალოგიური ფასის  მქონე ნივთში გადაცვლა. საკურირეო მომსახურების ხარჯებს ყველა შემთხვევაში ფარავს კომპანია.

პროდუქციის გაცვლა ან დაბრუნება შესაძლებელია მისი მიღებიდან 14 კალენდარული დღის განმავლობაში. ვადა აითვლება კლიენტისთვის პროდუქციის ჩაბარების დღიდან და იანგარიშება 14-ე დღის ჩათვლით.
პროდუქტის გაცვლა ან დაბრუნება შესაძლებელია იმ შემთხვევაში თუ პროდუქციას აქვს შენარჩუნებული სარეალიზაციო იერსახე, არ უნდა ჰქონდეს მოხმარების კვალი,  თან უნდა ჰქონდეს  დაუზიანებელი სარეალიზაციო ყუთი და არ უნდა ჰქონდეს მოხსნილი    ქარხნული იარლიყი.
წინდების, კოლგოტების, თეთრეულის, საცურაო კოსტიუმების, ბოდეების, აქსესუარების, თმის სამაგრების, საყურეების გაცვლა არ არის შესაძლებელი, გარდა იმ შემთხვევისა, როცა გაყიდულ ნივთი აღმოჩნდება ნაკლიანი!!
პროდუქტის დაბრუნებისას  თანხა   დაგერიცხებათ  5 სამუშაო დღემდე შუალედში იმავე ანგარიშზე, საიდანაც მოხდა თანხის გადახდა. 
პროდუქციის გაცვლას ან უკან დაბრუნებას კომპანია უზრუნველყობს ზემოთჩამოთვლილი პირობების გათვალისწინებით 5 კალენდარულ დღემდე პერიოდში. 

                                `}
                            <br />
                        </pre>


                            {/* Section 7 */}
                        <p className="text-lg md:text-xl">

                            {/* Section 8 */}
                            <h2 className="text-3xl md:text-4xl font-semibold text-orange-500 mt-12 mb-4 border-b-2 border-orange-300 pb-2">
                                {language === "en"
                                    ? "8. Contact Information:"
                                    : "8. საკონტაქტო ინფორმაცია:"}
                            </h2>
                            {language === "en"
                                ? "GND COMPANI LLC (Registration No. 402119694)"
                                : "შპს GND COMPANI (ს/კ 402119694)"}
                            <br />
                            {language === "en" ? "593 55 99 30" : "593 55 99 30"}
                        </p>
                        <div className="flex items-center gap-2">
                            <p className="text-lg md:text-xl font-bold transition-colors duration-300 hover:text-blue-500">
                                {language === "en"
                                    ? "Or write to us on messenger:"
                                    : "ან მოგვწერეთ მესენჯერში:"}
                            </p>
                            <a
                                className="text-blue-600 hover:text-blue-800 transition-colors duration-300"
                                target="_blank"
                                rel="noopener noreferrer"
                                href="https://www.facebook.com/profile.php?id=61569978551603"
                            >
                                <FaFacebookMessenger size={24} />
                            </a>
                        </div>
                    </div>
                </div>
            </section>

            <Footer />
            <ScrollToTop />
        </>
    );
}
